import { RootPaths } from "@src/appV2/App/paths";

export const PROOF_OF_EARNINGS_BASE_PATH = "proof-of-earnings";
export const PROOF_OF_EARNINGS_FULL_PATH = `${RootPaths.APP_V2_HOME}/${PROOF_OF_EARNINGS_BASE_PATH}`;
